import type { RouteProps } from "react-router";

import SignInPage from "pages/signIn/SignInPage";
import DashboardPage from "pages/dashboard/DashboardPage";
import ConfirmOtpPage from "pages/confirmOtp/ConfirmOtpPage";
import ManageProductPage from "pages/manageProduct/manageProductPages";
import ManageAgentPage from "pages/manageAgent/ManageAgentPage";
import CampaignPage from "pages/campaign/CampaignPage";
import ChatPage from "pages/chat/ChatPage";
import NotificationPage from "pages/notification/NotificationPage";
import ProfilesPage from "pages/profiles/ProfilesPage";
import CreateProductPage from "pages/manageProduct/createProductPage";
import ManageAgentbyIdPage from "pages/manageAgentbyId/manageAgentbyIdPage";
import UpdateProductPage from "pages/manageProduct/updateProductPage";
import NotFoundPage from "pages/notFound/NotFoundRoutePage";
import ProfileSettingPage from "pages/profiles/ProfileSetting";
import SettingMyProfile from "pages/profiles/SettingMyProfilePage";
import SettingmyQrCode from "pages/profiles/SettingmyQrCodePage";
import OrderAgentByIdPage from "pages/orderAgentById/OrderAgentByIdPage";
import SettingFactoryPage from "pages/profiles/SettingFactoryPage";
import SettingLineAlertPage from "pages/profiles/SettingLineAlert";
import ManageBankPage from "pages/manageBank/ManageBankPage";
import CreateAgentPage from "pages/manageAgent/createAgentPage";
import CreateOrderPage from "pages/order/createAgentPage";
import OrderPage from "pages/order/OrderPage";
import UpdateAgentPage from "pages/manageAgent/updateAgentPage";
import CreateBankPage from "pages/manageBank/CreateBankPage";
import UpdateBankPage from "pages/manageBank/UpdateBankPage";
import PrintDeliverynote from "pages/print-deliverynote/PrintDeliverynote";
import ShippingPage from "pages/shippingManage/ShippingPage";
import SettingShippingPage from "pages/profiles/SettingShipping";
import ManageShippingPage from "pages/manageShipping/ManageShipping";
import CreateShippingPage from "pages/manageShipping/CreateShippingPage";
import UpdateShippingPage from "pages/manageShipping/UpdateShippingPage";
import SettingPage from "pages/settingManage/settingPage";
import ManageTransportationPage from "pages/manageTransportation/ManageTransportationPage";
import CreateTransportationPage from "pages/manageTransportation/CreateTransportationPage";
import UpdateTransportationPage from "pages/manageTransportation/UpdateTransportationPage";
import BankDashboardPage from "pages/manageBank/BankDashboardPage";
import CreateRetailPage from "pages/manageRetail/createRetailPage";
import UpdateRetailPage from "pages/manageRetail/updateRetailPage";
import PrintLabelDelivery from "pages/print-label/delivery";
import DeliveryPointPage from "pages/deliveryPoint/DeliveryPointPage";
import ManageTaxInvoiceRequestPage from "pages/manageTaxInvoiceRequest/manageTaxInvoiceRequestPage";
import UserSystemPage from "pages/profiles/UserSystem";
import UpdateCampaignPage from "pages/campaign/updateCampaignPage";
import CreateCampaignPage from "pages/campaign/createCampaignPage";
import SettingPointPage from "pages/settingPoint";
import PointManagePage from "pages/pointManage/PointManage";
import SettingBoxPage from "pages/settingBox/SettingBoxPage";
import ManageFinance from "pages/manageFinance";
import AuthAdmin from "pages/authAdmin/AuthAdmin";
import PrintShippingLabelPage from "pages/printShippingLabel/PrintShippingLabelPage";
import ForgotPasswordPage from "pages/forgotPassword/ForgotPasswordPage";
import ResetPasswordPage from "pages/resetPassword/ResetPasswordPage";
import VerifyEmailPage from "pages/verifyEmail/VerifyEmailPage";
import ResendVerifyEmailPage from "pages/resendVerifyEmail/ResendVerifyEmailPage";
import ManageMerchantPage from "pages/manageMerchant/ManageMerchantPage";
import ManageParcelPage from "pages/manageParcel/ManageParcelPage";
import CreateManageParcelPage from "pages/manageParcel/CreateManageParcelPage";
import ManageCreditPage from "pages/manageCredit/ManageCreditPage";
import ManageCreditTopupPage from "pages/manageCredit/ManageCreditTopupPage";
import ManageCreditTopupCheckoutPage from "pages/manageCredit/ManageCreditTopupCheckoutPage";
import WarehousePage from "pages/warehouse/WarehousePage";
import TrainingPage from "pages/training/TrainingPage";

export type RouteKey =
  | "root"
  //| 'landing'
  | "signIn"
  | "authAdmin"
  | "dashboard"
  | "notFound"
  | "confirmOtp"
  | "order"
  | "orderById"
  | "createOrder"
  | "manageProduct"
  | "manageAgent"
  | "createAgent"
  | "updateAgent"
  // | 'manageRetail'
  | "createRetail"
  | "updateRetail"
  | "manageBank"
  | "createBank"
  | "updateBank"
  | "bankDashboard"
  | "manageShipping"
  | "createShipping"
  | "updateShipping"
  | "campaign"
  | "createCampaign"
  | "updateCampaign"
  | "chat"
  | "notification"
  | "profiles"
  | "createProduct"
  | "cloneProduct"
  // | 'manageAgentById'
  | "manageProductById"
  | "profileSetting"
  | "settingMyProfile"
  | "settingMyQrCode"
  // | 'oderAgentById'
  | "settingFactory"
  | "settingShipping"
  | "settingLineAlert"
  | "printDeliveryNote"
  | "shipping"
  | "setting"
  | "manageTransportation"
  | "createTransportation"
  | "updateTransportation"
  | "printlabel"
  | "deliveryPoint"
  | "manageTaxInvoiceList"
  | "userSystem"
  | "settingPoint"
  | "pointManage"
  | "settingBox"
  | "manageFinance"
  | "printShippingLabel"
  | "forgotPassword"
  | "resetPassword"
  | "verifyEmail"
  | "resendVerifyEmail"
  | "manageMerchant"
  | "manageParcel"
  | "createManageParcel"
  | "manageCredit"
  | "manageCreditTopup"
  | "manageCreditTopupCheckout"
  | "warehouse"
  | "training"

interface Middleware {
  requiredAuth?: boolean;
  roleList: string[];
}

interface AppRoute extends RouteProps {
  key: RouteKey;
  middleware?: Middleware;
}

export const paths: Record<RouteKey, string> = {
  root: "/",
  // landing: '/landing',
  signIn: "/sign-in",
  authAdmin: "/auth-admin/:key/:factory/:menu/:item/",
  dashboard: "/dashboard",
  notFound: "/not-found",
  confirmOtp: "/confirm-otp",
  order: "/order",
  orderById: "/order/:order_id",
  createOrder: "create-order",
  manageProduct: "/manage-product",
  manageAgent: "/manage-agent",
  manageBank: "/manage-bank",
  createBank: "/manage-bank/create",
  updateBank: "/manage-bank/update/:id",
  bankDashboard: "manage-bank/view/:id",
  manageShipping: "/manage-shipping",
  createShipping: "/manage-shipping/create",
  updateShipping: "/manage-shipping/update/:geography_id/:transport_type/:province_id/:district_id/:is_free",
  campaign: "/campaign",
  createCampaign: "/campaign/create-campaign",
  updateCampaign: "campaign/update-campaign/:id",
  chat: "/chat",
  notification: "/notification",
  profiles: "/profiles",
  createProduct: "/manage-product/create-product",
  cloneProduct: "/manage-product/create-product/clone/:id",
  // manageAgentById: '/manage-agent/:id',
  createAgent: "manage-agent/create-agent",
  updateAgent: "manage-agent/update-agent/:id",
  createRetail: "manage-agent/create-retail",
  updateRetail: "manage-agent/update-retail/:id",
  manageProductById: "/manage-product/edit/:id",
  profileSetting: "/profiles/profile-setting",
  settingMyProfile: "/profiles/setting-my-profile",
  settingMyQrCode: "profiles/my-qrcode",
  // oderAgentById: '/order-agent/:id',
  settingFactory: "/profiles/setting-factory",
  settingShipping: "/profiles/setting-shipping",
  settingLineAlert: "/profiles/setting-line-alert",
  userSystem: "/profiles/user-system",
  printDeliveryNote: "/print-deliverynote/:id",
  shipping: "/shipping",
  setting: "/setting",
  manageTransportation: "/manage-transportation",
  createTransportation: "/manage-transportation/create",
  updateTransportation: "/manage-transportation/update/:id",
  printlabel: "/print-label",
  deliveryPoint: "/delivery-point",
  manageTaxInvoiceList: "/manage-taxinvoice",
  settingPoint: "/setting-point",
  pointManage: "/point-manage",
  settingBox: "/setting-box",
  manageFinance: "/manage-finance",
  printShippingLabel: "/print-shipping-label",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  verifyEmail: "/verify-email",
  resendVerifyEmail: "/resend-verify-email",
  manageMerchant: "/manage-merchant",
  manageParcel: "/manage-parcel",
  createManageParcel: "/manage-parcel/create",
  manageCredit: "/manage-credit",
  manageCreditTopup: "/manage-credit/topup",
  manageCreditTopupCheckout: "/manage-credit/topup/checkout",
  warehouse: "/warehouse",
  training: "/training",
};

export const publicRoutes: AppRoute[] = [
  // {
  //   key: 'landing',
  //   path: paths.landing,
  //   element: <LandingPage />,
  // },
  {
    key: "authAdmin",
    path: paths.authAdmin,
    element: <AuthAdmin />,
  },
  {
    key: "signIn",
    path: paths.signIn,
    element: <SignInPage />,
  },
  {
    key: "confirmOtp",
    path: paths.confirmOtp,
    element: <ConfirmOtpPage />,
  },
  {
    key: "forgotPassword",
    path: paths.forgotPassword,
    element: <ForgotPasswordPage />,
  },
  {
    key: "resetPassword",
    path: paths.resetPassword,
    element: <ResetPasswordPage />,
  },
  {
    key: "verifyEmail",
    path: paths.verifyEmail,
    element: <VerifyEmailPage />,
  },
  {
    key: "resendVerifyEmail",
    path: paths.resendVerifyEmail,
    element: <ResendVerifyEmailPage />,
  },
];

export const adminPrivateRoutes: AppRoute[] = [
  {
    key: "dashboard",
    path: paths.dashboard,
    element: <DashboardPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "orderById",
    path: paths.orderById,
    element: <OrderPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "order",
    path: paths.order,
    element: <OrderPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createOrder",
    path: paths.createOrder,
    element: <CreateOrderPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageProduct",
    path: paths.manageProduct,
    element: <ManageProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageAgent",
    path: paths.manageAgent,
    element: <ManageAgentPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createAgent",
    path: paths.createAgent,
    element: <CreateAgentPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "updateAgent",
    path: paths.updateAgent,
    element: <UpdateAgentPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createRetail",
    path: paths.createRetail,
    element: <CreateRetailPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "updateRetail",
    path: paths.updateRetail,
    element: <UpdateRetailPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageBank",
    path: paths.manageBank,
    element: <ManageBankPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createBank",
    path: paths.createBank,
    element: <CreateBankPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "updateBank",
    path: paths.updateBank,
    element: <UpdateBankPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "bankDashboard",
    path: paths.bankDashboard,
    element: <BankDashboardPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageShipping",
    path: paths.manageShipping,
    element: <ManageShippingPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createShipping",
    path: paths.createShipping,
    element: <CreateShippingPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "updateShipping",
    path: paths.updateShipping,
    element: <UpdateShippingPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageTransportation",
    path: paths.manageTransportation,
    element: <ManageTransportationPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageTaxInvoiceList",
    path: paths.manageTaxInvoiceList,
    element: <ManageTaxInvoiceRequestPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createTransportation",
    path: paths.createTransportation,
    element: <CreateTransportationPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "updateTransportation",
    path: paths.updateTransportation,
    element: <UpdateTransportationPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "campaign",
    path: paths.campaign,
    element: <CampaignPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createCampaign",
    path: paths.createCampaign,
    element: <CreateCampaignPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "updateCampaign",
    path: paths.updateCampaign,
    element: <UpdateCampaignPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "chat",
    path: paths.chat,
    element: <ChatPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "notification",
    path: paths.notification,
    element: <NotificationPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "profiles",
    path: paths.profiles,
    element: <ProfilesPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createProduct",
    path: paths.createProduct,
    element: <CreateProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "cloneProduct",
    path: paths.cloneProduct,
    element: <CreateProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  // {
  //   key: 'manageAgentById',
  //   path: paths.manageAgentById,
  //   element: <ManageAgentbyIdPage />,
  //   middleware: {
  //     requiredAuth: true,
  //     roleList: [],
  //   },
  // },
  {
    key: "manageProductById",
    path: paths.manageProductById,
    element: <UpdateProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageProductById",
    path: "/manage-product/edit/:id/:owner",
    element: <UpdateProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "profileSetting",
    path: paths.profileSetting,
    element: <ProfileSettingPage />,
  },
  {
    key: "settingMyProfile",
    path: paths.settingMyProfile,
    element: <SettingMyProfile />,
  },
  {
    key: "settingMyQrCode",
    path: paths.settingMyQrCode,
    element: <SettingmyQrCode />,
  },
  {
    key: "settingFactory",
    path: paths.settingFactory,
    element: <SettingFactoryPage />,
  },
  {
    key: "settingShipping",
    path: paths.settingShipping,
    element: <SettingShippingPage />,
  },
  {
    key: "settingLineAlert",
    path: paths.settingLineAlert,
    element: <SettingLineAlertPage />,
  },
  {
    key: "userSystem",
    path: paths.userSystem,
    element: <UserSystemPage />,
  },
  // {
  //   key: 'oderAgentById',
  //   path: paths.oderAgentById,
  //   element: <OrderAgentByIdPage />,
  // },
  {
    key: "notFound",
    path: paths.notFound,
    element: <NotFoundPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "printDeliveryNote",
    path: paths.printDeliveryNote,
    element: <PrintDeliverynote />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "shipping",
    path: paths.shipping,
    element: <ShippingPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "setting",
    path: paths.setting,
    element: <SettingPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "printlabel",
    path: paths.printlabel,
    element: <PrintLabelDelivery />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "deliveryPoint",
    path: paths.deliveryPoint,
    element: <DeliveryPointPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "settingPoint",
    path: paths.settingPoint,
    element: <SettingPointPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "pointManage",
    path: paths.pointManage,
    element: <PointManagePage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "settingBox",
    path: paths.settingBox,
    element: <SettingBoxPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageFinance",
    path: paths.manageFinance,
    element: <ManageFinance />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "printShippingLabel",
    path: paths.printShippingLabel,
    element: <PrintShippingLabelPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageParcel",
    path: paths.manageParcel,
    element: <ManageParcelPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "createManageParcel",
    path: paths.createManageParcel,
    element: <CreateManageParcelPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageCredit",
    path: paths.manageCredit,
    element: <ManageCreditPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageCreditTopup",
    path: paths.manageCreditTopup,
    element: <ManageCreditTopupPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageCreditTopupCheckout",
    path: paths.manageCreditTopupCheckout,
    element: <ManageCreditTopupCheckoutPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "manageMerchant",
    path: paths.manageMerchant,
    element: <ManageMerchantPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "warehouse",
    path: paths.warehouse,
    element: <WarehousePage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: "training",
    path: paths.training,
    element: <TrainingPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
];

export const rolePermission = (
  accessToken: string | null | undefined,
  route: AppRoute
) => {
  if (!accessToken) {
    return false;
  }

  // const { roleList } = route.middleware || {}
  // const role  = user.role?.name

  // if(!role){
  //   return false
  // }

  // if (roleList?.includes(role)) {
  //   return true
  // }
  return false;
};
